import { initContract } from '@ts-rest/core';
import { agentContract } from './agent';
import { aveniContract } from './aveni-integration';
import { kycContract } from './kyc';
import { coacContract } from './coac';
import { reconciliationContract } from './reconciliation';
import { managerAliasContract } from './manager-alias';
import { firmConfigContract } from './firm-config';
import { onboardingContract } from './onboarding';
import { factFindContract } from './fact-find';
import { clientReviewContract } from './client-review';
import { clientBookContract } from './client-book';
import { portalContract } from './portal';
import { governanceContract } from './governance';
import { vulnerabilityContract } from './vulnerability';
import { pcfContract } from './pcf';
import { snapshotContract } from './snapshot';
import { kpiContract } from './kpi';
import { cashContract } from './cash';
import { sharePointContract } from './sharepoint';
import { opsContract } from './ops';
import { reportingContract } from './reporting';
import { reviewQueueContract } from './review-queue';
import { complyDashboardContract } from './comply-dashboard';
import { complyRegCalendarContract } from './comply-reg-calendar';
import { complyBreachRegisterContract } from './comply-breach-register';
import { complySuitabilityContract } from './comply-suitability';
import { complyConsumerDutyContract } from './comply-consumer-duty';
import { complyFinCrimeKycContract } from './comply-fin-crime-kyc';
import { complyTcTrackerContract } from './comply-tc-tracker';
import { complyCmpReviewsContract } from './comply-cmp-reviews';
import { complyFairValueContract } from './comply-fair-value';
import { complyCallIntelligenceContract } from './comply-call-intelligence';
import { deskPagesContract } from './desk-pages';
import { suitabilityAssessmentContract } from './suitability-assessment';
import { vulnerabilityAssessmentContract } from './vulnerability-assessment';
import { mandateLetterContract } from './mandate-letter';
import { deskDashboardContract } from './desk-dashboard';
import { viewPagesContract } from './view-pages';
import { viewClientIntelligenceContract } from './view-client-intelligence';
import { securityReferenceContract } from './security-reference';
import { userPrefsContract } from './user-prefs';
import { workflowsContract } from './workflows';
import { analyticsContract } from './analytics';

const c = initContract();

export const apiContract = c.router({
    agent: agentContract,
    coac: coacContract,
    onboarding: onboardingContract,
    factFind: factFindContract,
    clientReview: clientReviewContract,
    clientBook: clientBookContract,
    portal: portalContract,
    governance: governanceContract,
    vulnerability: vulnerabilityContract,
    pcf: pcfContract,
    reconciliation: reconciliationContract,
    snapshot: snapshotContract,
    kpi: kpiContract,
    cash: cashContract,
    managerAlias: managerAliasContract,
    firmConfig: firmConfigContract,
    sharePoint: sharePointContract,
    ops: opsContract,
    reporting: reportingContract,
    reviewQueue: reviewQueueContract,
    complyDashboard: complyDashboardContract,
    complyRegCalendar: complyRegCalendarContract,
    complyBreachRegister: complyBreachRegisterContract,
    complySuitability: complySuitabilityContract,
    complyConsumerDuty: complyConsumerDutyContract,
    complyFinCrimeKyc: complyFinCrimeKycContract,
    complyTcTracker: complyTcTrackerContract,
    complyCmpReviews: complyCmpReviewsContract,
    complyFairValue: complyFairValueContract,
    complyCallIntelligence: complyCallIntelligenceContract,
    deskPages: deskPagesContract,
    suitabilityAssessment: suitabilityAssessmentContract,
    vulnerabilityAssessment: vulnerabilityAssessmentContract,
    mandateLetter: mandateLetterContract,
    deskDashboard: deskDashboardContract,
    viewPages: viewPagesContract,
    viewClientIntelligence: viewClientIntelligenceContract,
    securityReference: securityReferenceContract,
    userPrefs: userPrefsContract,
    workflows: workflowsContract,
    analytics: analyticsContract,
    integrations: c.router({
        aveni: aveniContract,
        kyc: kycContract,
    }),
});

export {
    agentContract,
    aveniContract,
    kycContract,
    coacContract,
    onboardingContract,
    factFindContract,
    clientReviewContract,
    clientBookContract,
    portalContract,
    governanceContract,
    vulnerabilityContract,
    pcfContract,
    reconciliationContract,
    snapshotContract,
    kpiContract,
    cashContract,
    managerAliasContract,
    firmConfigContract,
    sharePointContract,
    opsContract,
    reportingContract,
    reviewQueueContract,
    complyDashboardContract,
    complyRegCalendarContract,
    complyBreachRegisterContract,
    complySuitabilityContract,
    complyConsumerDutyContract,
    complyFinCrimeKycContract,
    complyTcTrackerContract,
    complyCmpReviewsContract,
    complyFairValueContract,
    complyCallIntelligenceContract,
    deskPagesContract,
    suitabilityAssessmentContract,
    vulnerabilityAssessmentContract,
    mandateLetterContract,
    deskDashboardContract,
    viewPagesContract,
    viewClientIntelligenceContract,
    securityReferenceContract,
    userPrefsContract,
    workflowsContract,
    analyticsContract,
};
export type {
    AnalyticsEventKind,
    AnalyticsClientEventKind,
    AnalyticsClientEvent,
    AnalyticsIngestRequest,
    AnalyticsIngestResponse,
} from './analytics';
export {
    ANALYTICS_EVENT_KINDS,
    analyticsEventKindSchema,
    analyticsClientEventKindSchema,
    analyticsClientEventSchema,
    analyticsIngestRequestSchema,
    analyticsIngestResponseSchema,
} from './analytics';
export type {
    WorkflowSummary,
    ListWorkflowsResponse,
    GetWorkflowResponse,
    SaveWorkflowRequest,
    SaveWorkflowResponse,
    DeleteWorkflowResponse,
    RunWorkflowResponse,
    GetScheduleResponse,
    SetScheduleRequest,
    SetScheduleResponse,
    ClearScheduleResponse,
} from './workflows';
export type {
    SecurityRefStatusDto,
    SecurityReferenceDto,
    ResolveSecurityReferenceRequest,
    ResolveSecurityReferenceResponse,
} from './security-reference';
export type {
    ClientReviewStatus,
    ClientReviewOrigin,
    ReviewStepKey,
    StepDisposition,
    AnchorFreshness,
    RegisterFilter,
    ReviewStepState,
    ClientReview,
    RegisterRow,
    RegisterResponse,
    ClientHeader,
    ClientReviewDetail,
    ClientReviewDigest,
    OpenReviewRequest,
    DispositionStepRequest,
    CompleteReviewRequest,
    CancelReviewRequest,
} from './client-review';
export type {
    ClientSort,
    ClientGrouping,
    ClientComplianceStatus,
    ClientBookRow,
    ClientBookStats,
    ListClientsResponse,
    HouseholdGroup,
    ListHouseholdsResponse,
    ClientIdentity,
    ClientMandate,
    ClientPerformance,
    ClientFactFind,
    ClientReviewSummary,
    ClientHolding,
    ClientCash,
    ClientAccount as ClientBookAccount,
    HouseholdMember,
    ClientHousehold,
    ClientKycAssessment,
    ClientVulnerabilitySummary,
    ClientKyc,
    ClientDetail,
    MatchCandidate,
    MatchCandidatesResponse,
    CreateClientRequest,
    UpdateClientRequest,
    RegisterAccountRequest,
    CreateHouseholdRequest,
    AddClientToHouseholdRequest,
    AddRelatedPersonRequest,
    ConfirmMatchRequest,
} from './client-book';
export type {
    DeskDashboardStats,
    DeskDashboardClientRow,
    DeskDashboardResponse,
    DeskPerformanceRange,
    DeskBenchmarkRange,
} from './desk-dashboard';
export type {
    ComplyDashboardKpis,
    ComplyDashboardDeadline,
    ComplyAlertFeedItem,
    ComplyAttentionItem,
    ComplyDashboardResponse,
} from './comply-dashboard';
export type {
    ArtefactSummaryRow,
    CallArtefactRow,
    MonthlyNarrativeRow,
    ReviewQueuePendingResponse,
    FrontendReviewCounts,
    ReviewQueueCountsResponse,
} from './review-queue';
export type {
    RegulatoryReturnDto,
    RegulatoryReturnStatusDto,
    RegCalendarResponse,
} from './comply-reg-calendar';
export { regulatoryReturnStatusSchema } from './comply-reg-calendar';
export type {
    BreachCategoryDto,
    BreachSeverityDto,
    BreachRegisterStatusDto,
    BreachRegisterEntryDto,
    BreachRegisterResponse,
} from './comply-breach-register';
export {
    breachCategorySchema,
    breachSeveritySchema,
    breachRegisterStatusSchema,
} from './comply-breach-register';
export type {
    SuitabilityAlertDto,
    SuitabilityAlertTypeDto,
    SuitabilityAlertStatusDto,
    SuitabilityAlertSeverityDto,
    VigilFindingDto,
    SuitabilityResponse,
} from './comply-suitability';
export {
    suitabilityAlertTypeDtoSchema,
    suitabilityAlertStatusDtoSchema,
    suitabilityAlertSeverityDtoSchema,
} from './comply-suitability';
export type {
    ConsumerDutyResponse,
    ConsumerDutyAssessmentDto,
    ConsumerDutyClientScoreDto,
    VulnerableCustomerDto,
} from './comply-consumer-duty';
export type {
    FinCrimeKycResponse,
    EddOutcomeDto,
    KycReviewDto,
    EddCaseDto,
} from './comply-fin-crime-kyc';
export { eddOutcomeSchema } from './comply-fin-crime-kyc';
export type {
    TcTrackerResponse,
    TcRecordDto,
    CpdEntryDto,
    RecordCpdEntryBody,
} from './comply-tc-tracker';
export type {
    CmpReviewsResponse,
    CmpReviewItemDto,
    CmpFindingDto,
    AddCmpFindingBody,
} from './comply-cmp-reviews';
export type { FairValueResponse } from './comply-fair-value';
export type {
    CallIntelligenceResponse,
    CallExtractedFactDto,
    CallActionItemDto,
    CallKbNoteDto,
    CallIntelligenceDeskCallDto,
    CallIntelligenceClientDto,
} from './comply-call-intelligence';
export type {
    DeskClientKnowledgeResponse,
    DeskClientKB,
    DeskKBNote,
    DeskKBGraphNode,
    ClientKnowledgeDocumentDto,
    DeskCallsMeetingsResponse,
    DeskCallRow,
    DeskCallFactRow,
    DeskCallActionRow,
    DeskCallNoteRow,
    CallCitationSource,
    CallCitationSourcesResponse,
    OpsAuditLogEntryDto,
    OpsAuditLogResponse,
    AveniCallsTileResponse,
    AveniRiskTagRow,
    HoldingNoteRow,
    MandateCatalogueEntryDto,
    MandateCatalogueResponse,
    DeskPortfolioHoldingDto,
    DeskPortfolioHoldingsResponse,
    FeedItemDto,
    FeedItemActionOk,
} from './desk-pages';
export type {
    SuitabilityAssessmentFields,
    SuitabilityAssessmentDto,
    SuitabilityAssessmentGetResponse,
} from './suitability-assessment';
export {
    suitabilityAssessmentFieldsSchema,
    suitabilityAssessmentDtoSchema,
    suitabilityAssessmentGetResponseSchema,
} from './suitability-assessment';
export type {
    VulnerabilityAnswersDto,
    VulnerabilityAssessmentDto,
    VulnerabilityAssessmentGetResponse,
} from './vulnerability-assessment';
export {
    vulnerabilityAnswersSchema,
    vulnerabilityAssessmentDtoSchema,
    vulnerabilityAssessmentGetResponseSchema,
} from './vulnerability-assessment';
export type {
    MandateLetterInputs,
    MandateLetterContext,
    MandateLetterDto,
    MandateLetterGetResponse,
} from './mandate-letter';
export {
    mandateLetterInputsSchema,
    mandateLetterContextSchema,
    mandateLetterDtoSchema,
    mandateLetterGetResponseSchema,
} from './mandate-letter';
export type {
    ReviewableKind,
    ComposerAgent,
    StaffActionOk,
    StaffActionError,
    StaffActionResult,
    AgentTaskListQuery,
    ScheduledRun,
    ListScheduledRunsResponse,
} from './agent';
export {
    reviewableKindSchema,
    composerAgentSchema,
    staffActionOkSchema,
    staffActionErrorSchema,
    agentTaskListQuerySchema,
    scheduledRunSchema,
    listScheduledRunsResponseSchema,
} from './agent';
export type {
    FirmOverviewResponse,
    FirmOverviewBreach,
    FirmOverviewKycReview,
    FirmOverviewComplianceAlert,
    ViewAggregatesResponse,
    FundManagementListResponse,
    TrustDetailResponse,
    RnsAnnouncementDto,
    ItpBreachDto,
    // Fund-management row DTOs (the per-trust screens read these directly).
    InvestmentTrustRow,
    ExposureSnapshotRow,
    DiscountSnapshotRow,
    GearingSnapshotRow,
    PolicyClauseRow,
    ShareholderRow,
    ContinuationVoteRow,
    BrokerCoverageRow,
    FundReportDraftRow,
} from './view-pages';
export type {
    AttritionBand,
    AttritionRow,
    AttritionBandCounts,
    AttritionKpiSummary,
    ClientIntelligenceResponse,
} from './view-client-intelligence';
export { attritionBandSchema } from './view-client-intelligence';
export type {
    DocumentTaxonomy,
    VaultRow,
    SharePointStatus,
    ExportPdfRequest,
    ExportPdfResponse,
} from './sharepoint';
export type {
    AveniTranscript,
    AveniTranscriptTurn,
    AveniRiskTag,
    AveniRiskTagKind,
    AveniSentiment,
    AveniStatusResponse,
    AveniIngestRequest,
    AveniIngestResponse,
    AveniWebhookPayload,
    AveniAudioMetadata,
    AveniParticipant,
    AveniParticipantType,
    AveniCallDirection,
    AveniOrganisation,
    AveniSubmissionResult,
    AveniSubmitMetadataResponse,
} from './aveni-integration';
export type {
    KycVendor,
    KycMatch,
    KycScreenStatus,
    KycScreenResult,
    KycApplicant,
    KycScreenIndividualRequest,
    KycScreenEntityRequest,
    KycApplicantRequest,
    KycWebhookPayload,
    KycStatusResponse,
    KycVendorStatus,
} from './kyc';
export type {
    CoacActionRow,
    CoacActionListResponse,
    CoacElectionStatus,
    CoacOpsStatus,
    CoacRoutingOutcome,
    CoacUrgencyRating,
    CoacRouteToImRequest,
    CoacRecordDecisionRequest,
    CoacApproveElectionRequest,
    CoacDefaultElectionRequest,
    // Exposure (command centre — discretionary / advisory / execution-only split)
    CoacServiceType,
    CoacExposureBucket,
    CoacExposureSummary,
    CoacExposureSummaryRequest,
    CoacExposureLine,
    CoacExposureBreakdown,
    // Per-account elections (WP-E)
    CoacAccountElectionRow,
    CoacAccountElectionView,
    CoacRecordAccountElectionRequest,
    CoacImResponse,
    CoacResponsesBreakdown,
    CoacResponsesRow,
    CoacResponsesSummaryRow,
    CoacCompleteActionRequest,
    CoacTitanEmail,
    // ADR-0016 email draft types
    CoacEmailDraftRow,
    CoacApproveEmailDraftRequest,
} from './coac';
export type {
    OnboardingPipelineStage,
    OnboardingPipelineCaseStatus,
    OnboardingEnquirySource,
    KycResultStatus,
    MeetingPrepPack,
    PostMeetingNote,
    KycResult,
    SourceOfFundsDeclaration,
    OnboardingAuditEntry,
    OnboardingPipelineCase,
    OnboardingListResponse,
    OnboardingCaseResponse,
    CreateEnquiryRequest,
    AssignImRequest,
    TransitionRequest,
    PostMeetingNoteRequest,
    RemindRequest,
    ActorRequest,
    OnboardingCallKnowledgeResponse,
    OnboardingStageMetric,
    OnboardingAnalyticsResponse,
} from './onboarding';
export type {
    FactFindStatus,
    FactFindFreshness,
    FactFindClientType,
    CflBand,
    PrefillReviewStatus,
    VulnerabilityDriver,
    FactFindAnswer,
    FactFindResponse,
    AtrAssessment,
    CflWorkingStep,
    CflCalculation,
    FactFindVulnerabilityMarker,
    FactFindAnnotation,
    FactFindAuditEntry,
    FactFindVersion,
    FactFind,
    FactFindRegisterRow,
    FactFindRiskSummaryRow,
    FactFindRiskSummaryResponse,
    PrefillSuggestion,
    FactFindRegisterResponse,
    CreateDraftRequest,
    FactFindClientOption,
    FactFindClientsResponse,
    CreateFactFindRequest,
    CreateFactFindResponse,
    SaveSectionRequest,
    SaveAtrRequest,
    SaveCflRequest,
    FactFindTransitionRequest,
    AddAnnotationRequest,
    RefreshRequest,
    RefreshResponse,
    PrefillListResponse,
    PrefillActionResponse,
    FactFindSigningStatus,
    FactFindDocumentRecipient,
    FactFindDocument,
    FactFindDocumentResponse,
    FactFindSigningState,
    FactFindSigningStateResponse,
    SendForSignatureSigner,
    SendForSignatureRequest,
    MarkSignedRequest,
} from './fact-find';
export type {
    PortalSessionStatus,
    PortalMessageRole,
    PortalDeliveryChannel,
    PortalDocumentCategory,
    PortalNotificationKind,
    PortalNotificationStatus,
    PortalCitation,
    ClientPortalSession,
    ClientPortalMessage,
    PortalLibraryDocument,
    ClientDocumentAccess,
    ClientPortalNotification,
    PortalHolding,
    PortalTransaction,
    PortalDashboard,
    PortalOverdrawnAccount,
    PortalActionItem,
    PortalDocumentRef,
    PortalPortfolio,
    PortalCashAccount,
    PortalCashByCurrency,
    PortalCash,
    PortalExposureBand,
    PortalConcentrationLine,
    PortalExposure,
    PortalHoldingDetail,
    PortalHoldingDetailResponse,
    PortalProfile,
    LoginRequest,
    LoginResponse,
    PortalCredential,
    EnsureCredentialRequest,
    PortalSessionResponse,
    PostMessageRequest,
    PortalMessagesResponse,
    PortalDocumentsResponse,
    DocumentDownloadResponse,
    PortalNotificationsResponse,
    UpdateProfileRequest,
} from './portal';
export type {
    GovernanceMeetingKind,
    GovernanceRag,
    GovernanceStage,
    GovernanceItemStatus,
    GovernanceDecisionOutcome,
    GovernanceItemAuditEntry,
    GovernanceProgrammeItem,
    GovernanceDecision,
    GovernanceMeeting,
    GovernanceAgendaLine,
    GovernancePaper,
    StaleAmberFlag,
    GovernanceDriftResponse,
    GovernanceItemsResponse,
    GovernanceItemResponse,
    GovernanceMeetingsResponse,
    GovernanceMeetingDetailResponse,
    GovernancePapersResponse,
    StatusUpdateRequest,
} from './governance';
export type {
    VulnerabilitySeverity,
    VulnerabilityFlagDto,
    VulnerabilityEvidenceDto,
    VulnerabilityAdaptationPlanDto,
    VulnerabilityRecordDto,
    VulnerabilityDriverPrevalence,
    VulnerabilityDashboard,
    VulnerabilityCaseStudy,
    ConfirmFlagRequest,
    ConsentUpdateRequest,
} from './vulnerability';
export type {
    HouseModelAllocation,
    HouseModel,
    SecurityListEntry,
    PcfDeviationDetail,
    ImDeviationCell,
    PcfDashboard,
    BuyListImpactLine,
    BuyListChange,
    JustifyDeviationRequest,
    BuyListChangeRequest,
} from './pcf';
export type {
    ReconciliationBreakStatus,
    ReconciliationBreakDto,
    ReconciliationKind,
    ResolveBreakRequest,
    AssignBreakRequest,
    AutoResolveBreaksRequest,
    AutoResolveBreaksResponse,
    BreakResponse as ReconciliationBreakResponse,
    ListBreaksResponse,
    ReconciliationResultDto,
    MasonClassificationDto,
    ListResultsResponse,
} from './reconciliation';
export type { SnapshotDebugResponse } from './snapshot';
export type { OdCashRowDto, OverdrawnCashResponse, UploadOverdrawnCashResponse } from './cash';
export type { OpsTradeDto, OpsTradeStatus, ListTradesResponse } from './ops';
export { opsTradeDtoSchema, opsTradeStatusSchema, listTradesResponseSchema } from './ops';
export type {
    CashPositionRowDto,
    CashPositionAlertDto,
    CashPositionsResponse,
    UploadCashAccountsResponse,
} from './cash';
export type {
    ManagerAliasSource,
    ManagerAliasRow,
    ListManagerAliasesResponse,
    CreateManagerAliasRequest,
    CreateManagerAliasResponse,
} from './manager-alias';
export type {
    FirmConfigDto,
    FirmConfigPatchDto,
    TolerancesDto,
    TolerancesPatchDto,
    NotificationsPatchDto,
    AddUserRequest,
    UpdateUserRequest,
} from './firm-config';
export {
    firmConfigSchema,
    firmConfigPatchSchema,
    tolerancesSchema,
    tolerancesPatchSchema,
    notificationsPatchSchema,
    addUserRequestSchema,
} from './firm-config';
export type {
    KpiAggregateDto,
    KpiManagerAggregateDto,
    KpiPerCategoryDto,
    KpiPerManagerDto,
    KpiTrendPointDto,
    KpiFirmTotalsDto,
    KpiAumAuaDto,
    KpiFirmResponse,
    KpiMyResponse,
    ReportingCategory,
} from './kpi';
export {
    REPORTING_CATEGORIES,
    kpiAggregateSchema,
    kpiManagerAggregateSchema,
    kpiTrendPointSchema,
    kpiFirmResponseSchema,
    kpiMyResponseSchema,
} from './kpi';
export type {
    ReportCategory,
    ReportFrequency,
    ReportFormat,
    ReportDefinitionDto,
    ReportCatalogueResponse,
} from './reporting';
export {
    reportCategorySchema,
    reportFrequencySchema,
    reportFormatSchema,
    reportDefinitionSchema,
    reportCatalogueResponseSchema,
} from './reporting';
export type {
    SeverityFilter,
    NotificationPrefsDto,
    NotificationPrefsPatchDto,
    Theme,
    Density,
    DisplayPrefsDto,
    DisplayPrefsPatchDto,
} from './user-prefs';
export {
    severityFilterSchema,
    notificationPrefsSchema,
    notificationPrefsPatchSchema,
    themeSchema,
    densitySchema,
    displayPrefsSchema,
    displayPrefsPatchSchema,
} from './user-prefs';
